import { FC, ReactNode } from "react";
import Offcanvas from "react-bootstrap/Offcanvas";
import "./Drawer.style.css";
import closeIcon from "../../assets/images/closeIcon.svg";
import { Button } from "react-bootstrap";
import downloadIcon from "../../assets/images/downloadIcon.svg";
interface DrawerProps {
  isOpen: boolean;
  onClose: () => void;
  children?: ReactNode;
  title: string;
  subtitle: string;
}

const Drawer: FC<DrawerProps> = ({
  isOpen,
  onClose,
  children,
  title,
  subtitle,
}) => {
  return (
    <Offcanvas show={isOpen} onHide={onClose} placement="end" backdrop={false}>
      <Offcanvas.Header style={{ padding: 0, marginTop: "15px" }}>
        <Offcanvas.Title className="offcanvas-title">
          <div className="d-flex justify-content-between align-items-center">
            <div>
              <p className="offcanvas-title">{title}</p>
              <h1 className="offcanvas-subtitle">{subtitle}</h1>
            </div>
            <Button variant="light" className="ms-5 download-btn">
              Download
              <img
                src={downloadIcon}
                alt="Download Icon"
                className="download-Icon"
              />
            </Button>
          </div>
        </Offcanvas.Title>
        <img
          src={closeIcon}
          alt="Close"
          className="close-btn"
          onClick={onClose}
        />
      </Offcanvas.Header>
      <Offcanvas.Body>{children}</Offcanvas.Body>
    </Offcanvas>
  );
};

export default Drawer;
